import { classNames, tv } from "../../utils"

export const scaleTransformVariants = tv({
  base: classNames(
    "duration-200 ease-out-circ",
    "perspective-[0] translate-z-0 backface-hidden",
  ),
  variants: {
    group: {
      true: classNames(
        "group-hover:-translate-y-0.5 group-hover:scale-[1.01]",
        "group-active:scale-[1.005]",
      ),
      false: classNames(
        "hover:-translate-y-0.5 hover:scale-[1.01]",
        "active:scale-[1.005]",
      ),
    },
    shadow: {
      true: "shadow-xs",
      false: "",
    },
  },
  compoundVariants: [
    {
      group: false,
      shadow: true,
      className: "hover:shadow-xs",
    },
    {
      group: true,
      shadow: true,
      className: "group-hover:shadow-xs",
    },
  ],
})
